export default __webpack_public_path__ + "static/media/homeFraude.478bb231.svg";